// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: qheaGatNdWNWjNomb854R4
// Component: RVFHZQQuz8U
import * as React from "react"
import { Link } from "gatsby"
import * as p from "@plasmicapp/react-web"
import * as ph from "@plasmicapp/host"
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
} from "@plasmicapp/react-web"
import Button from "../../Button" // plasmic-import: PYZjcqsUjd1/component
import { useScreenVariants as useScreenVariantsdrDuv2SCfUGy4Z } from "./PlasmicGlobalVariant__Screen" // plasmic-import: DrDUV2sCfUGy4Z/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css"
import * as projectcss from "./plasmic_dork_squad.module.css" // plasmic-import: qheaGatNdWNWjNomb854R4/projectcss
import * as sty from "./PlasmicPortfolio.module.css" // plasmic-import: RVFHZQQuz8U/css
import IconIcon from "./icons/PlasmicIcon__Icon" // plasmic-import: U5di6eDCbmGOfi/icon
import dorkSquadLogosvgWnQb1DIoB from "./images/dorkSquadLogosvg.svg" // plasmic-import: wnQb1DIoB/picture

export const PlasmicPortfolio__VariantProps = new Array()

export const PlasmicPortfolio__ArgProps = new Array("mail")

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn())

const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    await promise
  })

export function Head() {
  return (
    <>
      <meta name="twitter:card" content="summary_large_image" />
      <title key="title">{PlasmicPortfolio.pageMetadata.title}</title>
      <meta
        key="og:title"
        property="og:title"
        content={PlasmicPortfolio.pageMetadata.title}
      />

      <meta
        key="twitter:title"
        name="twitter:title"
        content={PlasmicPortfolio.pageMetadata.title}
      />

      <meta
        key="description"
        name="description"
        content={PlasmicPortfolio.pageMetadata.description}
      />

      <meta
        key="og:description"
        property="og:description"
        content={PlasmicPortfolio.pageMetadata.description}
      />

      <meta
        key="twitter:description"
        name="twitter:description"
        content={PlasmicPortfolio.pageMetadata.description}
      />

      <meta
        key="og:image"
        property="og:image"
        content={PlasmicPortfolio.pageMetadata.ogImageSrc}
      />

      <meta
        key="twitter:image"
        name="twitter:image"
        content={PlasmicPortfolio.pageMetadata.ogImageSrc}
      />

      <link ref="canonical" href={PlasmicPortfolio.pageMetadata.canonical} />
    </>
  )
}

function PlasmicPortfolio__RenderFunc(props) {
  const { variants, overrides, forNode } = props
  const $ctx = ph.useDataEnv?.() || {}
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          mail: "mailto:info@dorksquad.net",
        },

        props.args
      ),

    [props.args]
  )

  const $props = {
    ...args,
    ...variants,
  }

  const currentUser = p.useCurrentUser?.() || {}
  const [$queries, setDollarQueries] = React.useState({})
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsdrDuv2SCfUGy4Z(),
  })

  return (
    <React.Fragment>
      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={projectcss.plasmic_page_wrapper}>
        <p.Stack
          as={"div"}
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          hasGap={true}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          <p.Stack
            as={"div"}
            data-plasmic-name={"header"}
            data-plasmic-override={overrides.header}
            hasGap={true}
            className={classNames(projectcss.all, sty.header)}
          >
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__r07T0)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__lAdBz)}>
                <p.PlasmicImg
                  data-plasmic-name={"img"}
                  data-plasmic-override={overrides.img}
                  alt={""}
                  className={classNames(sty.img)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? "180px"
                      : "100px"
                  }
                  loading={"lazy"}
                  src={{
                    src: dorkSquadLogosvgWnQb1DIoB,
                    fullWidth: 208,
                    fullHeight: 150,
                    aspectRatio: 1.385768,
                  }}
                />
              </div>

              {true ? (
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__zwPvh)}
                >
                  <p.PlasmicLink
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.link__bwQoZ
                    )}
                    component={Link}
                    platform={"gatsby"}
                  >
                    <p.PlasmicLink
                      data-plasmic-name={"experiences"}
                      data-plasmic-override={overrides.experiences}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        sty.experiences
                      )}
                      component={Link}
                      href={`/`}
                      platform={"gatsby"}
                    >
                      {"Experiences"}
                    </p.PlasmicLink>
                  </p.PlasmicLink>

                  <p.Stack
                    as={p.PlasmicLink}
                    hasGap={true}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.link__sqbbE
                    )}
                    component={Link}
                    platform={"gatsby"}
                  >
                    {false ? (
                      <IconIcon
                        className={classNames(projectcss.all, sty.svg__grD9L)}
                        role={"img"}
                      />
                    ) : null}

                    <p.PlasmicLink
                      data-plasmic-name={"services"}
                      data-plasmic-override={overrides.services}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        sty.services
                      )}
                      component={Link}
                      platform={"gatsby"}
                    >
                      {"Our motive"}
                    </p.PlasmicLink>

                    {false ? (
                      <IconIcon
                        className={classNames(projectcss.all, sty.svg__xn1Tc)}
                        role={"img"}
                      />
                    ) : null}
                  </p.Stack>

                  <p.Stack
                    as={p.PlasmicLink}
                    hasGap={true}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.link__hbjBq
                    )}
                    component={Link}
                    platform={"gatsby"}
                  >
                    {false ? (
                      <IconIcon
                        className={classNames(projectcss.all, sty.svg__poDka)}
                        role={"img"}
                      />
                    ) : null}

                    <p.PlasmicLink
                      data-plasmic-name={"gallery"}
                      data-plasmic-override={overrides.gallery}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        sty.gallery
                      )}
                      component={Link}
                      platform={"gatsby"}
                    >
                      {"Gallery"}
                    </p.PlasmicLink>

                    {false ? (
                      <IconIcon
                        className={classNames(projectcss.all, sty.svg__wjSk1)}
                        role={"img"}
                      />
                    ) : null}
                  </p.Stack>

                  <p.Stack
                    as={p.PlasmicLink}
                    hasGap={true}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.link___890Et
                    )}
                    component={Link}
                    platform={"gatsby"}
                  >
                    {false ? (
                      <IconIcon
                        className={classNames(projectcss.all, sty.svg__jQClH)}
                        role={"img"}
                      />
                    ) : null}

                    <p.PlasmicLink
                      data-plasmic-name={"about"}
                      data-plasmic-override={overrides.about}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        sty.about
                      )}
                      component={Link}
                      platform={"gatsby"}
                    >
                      {"About"}
                    </p.PlasmicLink>

                    {false ? (
                      <IconIcon
                        className={classNames(projectcss.all, sty.svg__pQc7D)}
                        role={"img"}
                      />
                    ) : null}
                  </p.Stack>
                </p.Stack>
              ) : null}
              {false ? (
                <div className={classNames(projectcss.all, sty.freeBox__vCLtU)}>
                  <button
                    className={classNames(
                      projectcss.all,
                      projectcss.button,
                      projectcss.__wab_text,
                      sty.button__z4Bxk
                    )}
                  >
                    {"Sign up"}
                  </button>

                  <p.Stack
                    as={p.PlasmicLink}
                    hasGap={true}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.link__aPopg
                    )}
                    component={Link}
                    platform={"gatsby"}
                  >
                    {false ? (
                      <IconIcon
                        className={classNames(projectcss.all, sty.svg__vPBfS)}
                        role={"img"}
                      />
                    ) : null}

                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__mTdm6
                      )}
                    >
                      {"Log in"}
                    </div>

                    {false ? (
                      <IconIcon
                        className={classNames(projectcss.all, sty.svg__gx1IH)}
                        role={"img"}
                      />
                    ) : null}
                  </p.Stack>
                </div>
              ) : null}
            </p.Stack>
          </p.Stack>

          <div
            data-plasmic-name={"groupPicture"}
            data-plasmic-override={overrides.groupPicture}
            className={classNames(projectcss.all, sty.groupPicture)}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"foreground2"}
              data-plasmic-override={overrides.foreground2}
              hasGap={true}
              className={classNames(projectcss.all, sty.foreground2)}
            >
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__mwSu)}
              >
                <h1
                  data-plasmic-name={"h1"}
                  data-plasmic-override={overrides.h1}
                  className={classNames(
                    projectcss.all,
                    projectcss.h1,
                    projectcss.__wab_text,
                    sty.h1
                  )}
                >
                  {"Our legacy"}
                </h1>

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__xHjSl
                  )}
                >
                  {
                    "Since our group establishment in 2019, we started off with the goal to make immersive experiences for players of all age ranges to enjoy.\nEver since, we have carefully shaped our own universe of custom stories about those experiences, as you will see below."
                  }
                </div>
              </p.Stack>
            </p.Stack>
          </div>

          {(
            hasVariant(globalVariants, "screen", "_4KMonitors") ? true : false
          ) ? (
            <div
              data-plasmic-name={"hoarfrost"}
              data-plasmic-override={overrides.hoarfrost}
              className={classNames(projectcss.all, sty.hoarfrost)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__auyn6)}>
                {(
                  hasVariant(globalVariants, "screen", "mobileOnly")
                    ? true
                    : true
                ) ? (
                  <div
                    className={classNames(projectcss.all, sty.columns__fQt6T)}
                  >
                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.column__c9XEa)}
                    >
                      <h2
                        className={classNames(
                          projectcss.all,
                          projectcss.h2,
                          projectcss.__wab_text,
                          sty.h2___9CwYz
                        )}
                      >
                        {"Hoarfrost"}
                      </h2>

                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___9NnTb
                        )}
                      >
                        {
                          "On your way to help your fellow friend Jordan, you find out about his inheritance from his grandfather and on a long forgotten curse, that haunts the very place he used to call his home...\nYou set off with up to 4 players to an Alaskan mountain region, uncover a dark secret that lives below the snow. Don't forget to bring warm clothing!"
                        }
                      </div>

                      <Button
                        className={classNames(
                          "__wab_instance",
                          sty.button__ykYkh
                        )}
                        color={"dorkBlue"}
                        link={"https://rec.net/room/Hoarfrost"}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__fkOd
                          )}
                        >
                          {"View on Rec.Net"}
                        </div>
                      </Button>
                    </p.Stack>

                    {(
                      hasVariant(globalVariants, "screen", "mobileOnly")
                        ? true
                        : true
                    ) ? (
                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(
                          projectcss.all,
                          sty.column__xs0Nr
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__dKVjr
                          )}
                          loading={"lazy"}
                        />
                      </p.Stack>
                    ) : null}
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
          {(
            hasVariant(globalVariants, "screen", "_4KMonitors") ? true : false
          ) ? (
            <div
              data-plasmic-name={"yuleFest"}
              data-plasmic-override={overrides.yuleFest}
              className={classNames(projectcss.all, sty.yuleFest)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__cSxwI)}>
                <div className={classNames(projectcss.all, sty.columns__eYqDw)}>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.column__jmwNg)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__xx1KX)}
                      loading={"lazy"}
                    />
                  </p.Stack>

                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.column___8S6AO)}
                  >
                    <h2
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.h2__tdZ5D
                      )}
                    >
                      {"Yule Fest"}
                    </h2>

                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__j0Why
                      )}
                    >
                      {
                        "Combining classic viking traditions and the rather largely covered yule festivities, will lead you to this calm place. In our art map ^YuleFest you will not only learn a lot about vikings, yule and old Danish legacies, but also feel immersed in the environment it brings along!"
                      }
                    </div>

                    <Button
                      className={classNames(
                        "__wab_instance",
                        sty.button__rjIlR
                      )}
                      color={"dorkBlue"}
                      link={"https://rec.net/room/YuleFest"}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___0NthF
                        )}
                      >
                        {"View on Rec.Net"}
                      </div>
                    </Button>
                  </p.Stack>
                </div>
              </div>
            </div>
          ) : null}
          {(
            hasVariant(globalVariants, "screen", "_4KMonitors") ? true : false
          ) ? (
            <div
              data-plasmic-name={"gruyeres"}
              data-plasmic-override={overrides.gruyeres}
              className={classNames(projectcss.all, sty.gruyeres)}
            >
              <div className={classNames(projectcss.all, sty.freeBox___6XixD)}>
                <div className={classNames(projectcss.all, sty.columns__bWpWg)}>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.column__ht9K)}
                  >
                    <h2
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.h2__tjSoI
                      )}
                    >
                      {"Gruyeres"}
                    </h2>

                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__ugdA9
                      )}
                    >
                      {
                        "This hangout place brings you to a specificly comfy region of Switzerland, where you get to enjoy the feeling of strolling through a local town and enjoying the view that comes along with it.\nAn accurate recreation of the town Gruyeres from the Fribourg canton, Switzerland."
                      }
                    </div>

                    <Button
                      className={classNames(
                        "__wab_instance",
                        sty.button__mRlOx
                      )}
                      color={"dorkBlue"}
                      link={"https://rec.net/room/Gruyeres"}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___8XoBv
                        )}
                      >
                        {"View on Rec.Net"}
                      </div>
                    </Button>
                  </p.Stack>

                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.column__gn5Gu)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__rbLms)}
                      loading={"lazy"}
                    />
                  </p.Stack>
                </div>
              </div>
            </div>
          ) : null}
          {(
            hasVariant(globalVariants, "screen", "_4KMonitors") ? true : false
          ) ? (
            <div
              data-plasmic-name={"voidResonance"}
              data-plasmic-override={overrides.voidResonance}
              className={classNames(projectcss.all, sty.voidResonance)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__kV0Is)}>
                <div className={classNames(projectcss.all, sty.columns__fTQsq)}>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.column__kEUkg)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__ugSkz)}
                      loading={"lazy"}
                    />
                  </p.Stack>

                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.column__z27RO)}
                  >
                    <h2
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.h2__ysOFg
                      )}
                    >
                      {"Void Resonance"}
                    </h2>

                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__dp0H1
                      )}
                    >
                      {
                        "Our first major music event, featuring our in-house producer and a guest producer. In this synchronised show, we unleashed lots of flashing lights,\nlasers and other immersive effects onto the watching crowd. Even though it was a one-time play, it our own personal milestone for future projects."
                      }
                    </div>

                    <Button
                      className={classNames(
                        "__wab_instance",
                        sty.button__qsnNx
                      )}
                      color={"dorkBlue"}
                      link={"https://rec.net/event/1520144"}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__hVikj
                        )}
                      >
                        {"View on Rec.Net"}
                      </div>
                    </Button>
                  </p.Stack>
                </div>
              </div>
            </div>
          ) : null}
          {(
            hasVariant(globalVariants, "screen", "_4KMonitors") ? true : false
          ) ? (
            <div
              data-plasmic-name={"fishingJamboree"}
              data-plasmic-override={overrides.fishingJamboree}
              className={classNames(projectcss.all, sty.fishingJamboree)}
            >
              <div className={classNames(projectcss.all, sty.freeBox___945F)}>
                <div className={classNames(projectcss.all, sty.columns__j5EMk)}>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.column___3A2Ob)}
                  >
                    <h2
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.h2__m2XHx
                      )}
                    >
                      {"Fishing Jamboree"}
                    </h2>

                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__ga3Ns
                      )}
                    >
                      {
                        "An interactive fishing mini-game with a lot of little easter eggs.\nIncludes full universal platform support and a leaderboard setup to share scores with your fellow friends! This game also introduces an almost 1 hour long music playlist that you can dynamically adjust for yourself and others."
                      }
                    </div>

                    <Button
                      className={classNames(
                        "__wab_instance",
                        sty.button__xCj3W
                      )}
                      color={"dorkBlue"}
                      link={"https://rec.net/room/FishingJamboree"}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__spM4J
                        )}
                      >
                        {"View on Rec.Net"}
                      </div>
                    </Button>
                  </p.Stack>

                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.column__mKJU)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox___4AgCf
                      )}
                      loading={"lazy"}
                    />
                  </p.Stack>
                </div>
              </div>
            </div>
          ) : null}

          <div
            data-plasmic-name={"edgeOfUnknown"}
            data-plasmic-override={overrides.edgeOfUnknown}
            className={classNames(projectcss.all, sty.edgeOfUnknown)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__e0CJo)}>
              <div className={classNames(projectcss.all, sty.columns__fAwUx)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__vrcJq)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__dMm81)}
                    loading={"lazy"}
                  />
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__advng)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__quvA8
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "_4KMonitors")
                      ? "Edge Of Unknown"
                      : "Edge Of Unknown"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__qg0Xa
                    )}
                  >
                    {
                      "You embark with your crew on a colossal journey to discover new planets and lifeforms. After crash-landing on a newly discovered planet, you are tasked with fixing your ship and finding out who or what got you into this situation to begin with. \nFeatures a cinematic intro and open-world capabilities bundled with automatic checkpoints."
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__cKIfV)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/EdgeOfUnknown"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__ptmqP
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"shibuyaCrossing"}
            data-plasmic-override={overrides.shibuyaCrossing}
            className={classNames(projectcss.all, sty.shibuyaCrossing)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__rciSq)}>
              <div className={classNames(projectcss.all, sty.columns__vTxBc)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__j5TJx)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2___3VJql
                    )}
                  >
                    {"Shibuya Crossing"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__ioe8L
                    )}
                  >
                    {
                      "Explore a 1-to-1 scale build of the Popular crossing located in Tokyo, Japan! \nVisit a Korean BBQ, shop at a local geek store and go on train rides to mysterious locations! \nWhatever you do, do NOT open the Manhole cover."
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__pggJ)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/ShibuyaCrossing"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__rj87F
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__usffj)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__iIjip)}
                    loading={"lazy"}
                  />
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"runesOfEtheria"}
            data-plasmic-override={overrides.runesOfEtheria}
            className={classNames(projectcss.all, sty.runesOfEtheria)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__yqWtV)}>
              <div className={classNames(projectcss.all, sty.columns__kcX2B)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column___2Ce2K)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__nJdtC)}
                    loading={"lazy"}
                  />
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__do6F)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__gX8Mq
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "_4KMonitors")
                      ? "Runes Of Etheria"
                      : "Runes Of Etheria"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__xFjqg
                    )}
                  >
                    {
                      "Your bike's tire is flat, and you're stuck in a forest. Oh well, at least you're not transported by a deer god to an alternate dimension full of mythical forest creatures...\nOh, never mind."
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__gcZz)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/RunesOfEtheria"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__vgVxl
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"pizzaAndOranges"}
            data-plasmic-override={overrides.pizzaAndOranges}
            className={classNames(projectcss.all, sty.pizzaAndOranges)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__tfRzB)}>
              <div className={classNames(projectcss.all, sty.columns__a4Uf)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__zxm38)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__lqpHy
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "_4KMonitors")
                      ? "Pizza and Oranges"
                      : "Pizza and Oranges"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__me5Nb
                    )}
                  >
                    {
                      'A whacky adventure througout the Italian town "Città Arancione".\nYou set out to help the town\'s mayor to save the local festival that is being threatened by a rival town.'
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__tyrpr)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/PizzaAndOranges"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__f5Rt
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__znF9K)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__w4QxF)}
                    loading={"lazy"}
                  />
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"jetSkater"}
            data-plasmic-override={overrides.jetSkater}
            className={classNames(projectcss.all, sty.jetSkater)}
          >
            <div className={classNames(projectcss.all, sty.freeBox___4UuBh)}>
              <div className={classNames(projectcss.all, sty.columns__yHhIw)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column___9ZAeM)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__seuJv)}
                    loading={"lazy"}
                  />
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column___6F0Jo)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__g7CIj
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "_4KMonitors")
                      ? "Jet Skater"
                      : "Jet Skater"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__a6Thq
                    )}
                  >
                    {
                      "Using early beta CV2 circuits, we revisit the old skating games, but with hand gestures instead. This VR-only minigame lets you perform stunts and tricks with fun sound effects, animations and Royalty-free music."
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__kyTic)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/JetSkater"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___1GLiK
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"theHeartOfWerahuri"}
            data-plasmic-override={overrides.theHeartOfWerahuri}
            className={classNames(projectcss.all, sty.theHeartOfWerahuri)}
          >
            <div className={classNames(projectcss.all, sty.freeBox___3Vp4Z)}>
              <div className={classNames(projectcss.all, sty.columns__icwhu)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__i5O92)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2___2CJuB
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "_4KMonitors")
                      ? "The Heart of Werahuri"
                      : "The Heart of Werahuri"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__aq9N
                    )}
                  >
                    {
                      "You and your fellow adventurers land on a remote island to look for a strange unknown artifact. This epic adventure leads you on a path through dangerous environments and challenging puzzles.\nThis is our first quest that starts off with a cinematic intro, further improving the immersion of the players."
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__sGeXt)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/TheHeartOfWerahuri"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__gtcs3
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column___2PsnB)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__oaYjI)}
                    loading={"lazy"}
                  />
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"stoneCircle"}
            data-plasmic-override={overrides.stoneCircle}
            className={classNames(projectcss.all, sty.stoneCircle)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__fSnUk)}>
              <div className={classNames(projectcss.all, sty.columns___2IylX)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column___8Z1W)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__zG2Q7)}
                    loading={"lazy"}
                  />
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__oIBeB)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__w0CT6
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "_4KMonitors")
                      ? "Stone Circle"
                      : "Stone Circle"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__faloB
                    )}
                  >
                    {
                      "Enjoy the calm atmosphere beyond the fields where an ancient and mysterious stone circle stands. This place focuses on presenting you with an interesting new sight on depth and distance. Look closely!"
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__hm3Yq)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/StoneCircle"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__aqKv
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"smoggCityTheRpvpg"}
            data-plasmic-override={overrides.smoggCityTheRpvpg}
            className={classNames(projectcss.all, sty.smoggCityTheRpvpg)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__tpiZr)}>
              <div className={classNames(projectcss.all, sty.columns__kuxg1)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column___4IdoZ)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__hOpae
                    )}
                  >
                    {"SmoggCity the RPVPG"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__vpB6T
                    )}
                  >
                    {
                      "A class based PvP in a dystopian future environment.\nExpect high-octane action!"
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button___3B6Je)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/SmoggCity_the_RPVPG"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__wLGud
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__gxnj1)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__pRhtW)}
                    loading={"lazy"}
                  />
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"dorkReactor"}
            data-plasmic-override={overrides.dorkReactor}
            className={classNames(projectcss.all, sty.dorkReactor)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__hkYb)}>
              <div className={classNames(projectcss.all, sty.columns__n7O0J)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__yGqpb)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__m8HAg)}
                    loading={"lazy"}
                  />
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column___8EtGf)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__b5TRj
                    )}
                  >
                    {"DorkReactor"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__yrLdf
                    )}
                  >
                    {
                      "Manage a functioning nuclear reactor simulated in real time, interact with various machines around the power plant and face disasters when things get out of control."
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__wg5PI)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/DorkReactor"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__vTWzj
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"proficioVii"}
            data-plasmic-override={overrides.proficioVii}
            className={classNames(projectcss.all, sty.proficioVii)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__r7NL)}>
              <div className={classNames(projectcss.all, sty.columns__kM8Ud)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__aHnX1)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__g08Rd
                    )}
                  >
                    {"ProficioVII"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__naQh7
                    )}
                  >
                    {
                      "You wake up from stasis on a deserted lunar base, that has been strongly damaged by an unknown energy being. You slowly uncover all the secrets about the alien lifeform and learn the true fate of humanity.\nA multi-path quest with a fully integrated save system."
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__a2Pqk)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/ProficioVII"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__nzlNb
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__mZxAo)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox___0TP)}
                    loading={"lazy"}
                  />
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"sandySunsetIsland"}
            data-plasmic-override={overrides.sandySunsetIsland}
            className={classNames(projectcss.all, sty.sandySunsetIsland)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__aIeLx)}>
              <div className={classNames(projectcss.all, sty.columns__x6KQk)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__qqOit)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__z5LuI)}
                    loading={"lazy"}
                  />
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__bSoX)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__poOsm
                    )}
                  >
                    {"Sandy Sunset Island"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__vtmvg
                    )}
                  >
                    {
                      "Hang out on a sunny little island with lots of cute little characters and really embrace your summer vibes!"
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__nrU7Q)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/SandySunsetIsland"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__rmgz9
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"travelBeyondInc"}
            data-plasmic-override={overrides.travelBeyondInc}
            className={classNames(projectcss.all, sty.travelBeyondInc)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__lyiR)}>
              <div className={classNames(projectcss.all, sty.columns___869C1)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__z7Iaq)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__tPqOa
                    )}
                  >
                    {"Travel Beyond Inc"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__ecqt4
                    )}
                  >
                    {
                      "Relax on a virtual train ride through various environments. Great room to visit either for unwinding by yourself, but also a calm place to bring your friends to when you just want to have a chat and enjoy the scenery."
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button___9Im6H)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/TravelBeyondInc"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__jQztc
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__e0NSa)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__fgTx)}
                    loading={"lazy"}
                  />
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"whatBunker"}
            data-plasmic-override={overrides.whatBunker}
            className={classNames(projectcss.all, sty.whatBunker)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__odKf)}>
              <div className={classNames(projectcss.all, sty.columns__qiVpF)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__yt61I)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__ohWcO)}
                    loading={"lazy"}
                  />
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__lHgF)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__xhWI
                    )}
                  >
                    {"WhatBunker"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___7Ajhu
                    )}
                  >
                    {
                      "Enjoy the fresh air of the desert and the charming heat of a thermonuclear explosion.\nOr simply chill out with your friends in the fanciest bunker ever build.\nA hangout with a spicy intro, hold onto something!"
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__efpHc)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/WhatBunker"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__wpydO
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"clockingOff"}
            data-plasmic-override={overrides.clockingOff}
            className={classNames(projectcss.all, sty.clockingOff)}
          >
            <div className={classNames(projectcss.all, sty.freeBox___7UPIo)}>
              <div className={classNames(projectcss.all, sty.columns__xzuO1)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__mJnn6)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2___5BdN9
                    )}
                  >
                    {"Clocking Off"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__cqXu1
                    )}
                  >
                    {
                      "You daydream on your mundane office job and accidently plunge into an enigmatic world of wacky characters helping you on your quest to fix time itself.\nIncludes many original characters, which later became the foundation of some of our new ideas."
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__surkh)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/ClockingOff"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__nkmU0
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__ggqHv)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__ghr1)}
                    loading={"lazy"}
                  />
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"aostabla"}
            data-plasmic-override={overrides.aostabla}
            className={classNames(projectcss.all, sty.aostabla)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__noEj)}>
              <div className={classNames(projectcss.all, sty.columns__cv9E1)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column___6Ul87)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__wjr7V)}
                    loading={"lazy"}
                  />
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column___5VcHp)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__xvhq5
                    )}
                  >
                    {"Aostabla"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__nhcFk
                    )}
                  >
                    {
                      "Explore a magical land and embark on an epic journey to defeat the evil wizard Purpelius.\nFace many enemies and huge bosses that will challenge your skills."
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__jG8LN)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/Aostabla"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__yoea6
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"arthurLokinsIsland"}
            data-plasmic-override={overrides.arthurLokinsIsland}
            className={classNames(projectcss.all, sty.arthurLokinsIsland)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__xIp3E)}>
              <div className={classNames(projectcss.all, sty.columns__zkVxW)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__y8AFg)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__luk7N
                    )}
                  >
                    {"Arthur Lokins Island"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__gm4Yz
                    )}
                  >
                    {
                      "You find out about a hidden treasure and set sail with your fellow fluffy, lovable crewmates.\nFeatures fully animated characters."
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__et7MN)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/ArthurLokinsIsland"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__v7Cya
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__iVuPs)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__pbvda)}
                    loading={"lazy"}
                  />
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"theSeaFloor"}
            data-plasmic-override={overrides.theSeaFloor}
            className={classNames(projectcss.all, sty.theSeaFloor)}
          >
            <div className={classNames(projectcss.all, sty.freeBox___7MmL)}>
              <div className={classNames(projectcss.all, sty.columns___6KVfw)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__zIinb)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox___5N0A6)}
                    loading={"lazy"}
                  />
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__oArne)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2___0C9Tk
                    )}
                  >
                    {"The Sea Floor"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__snuxP
                    )}
                  >
                    {
                      "Hidden far underneath the ocean, the true beauty of the sea floor is uncovered. Visit a tranquil underwater structure with your friends and get up close to high-detail models of the fantasy underwater creatures that the team made for this art map."
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button___3GzD3)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/TheSeaFloor"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__pePcE
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"yarrHarrHeist"}
            data-plasmic-override={overrides.yarrHarrHeist}
            className={classNames(projectcss.all, sty.yarrHarrHeist)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__xOtjj)}>
              <div className={classNames(projectcss.all, sty.columns___6IkI)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__brWcV)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__qRSz
                    )}
                  >
                    {"YarrHarrHeist"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__rxQbR
                    )}
                  >
                    {
                      "Run, sneak, and climb with your friends to recover a powerful artifact from Captain Stinkbeard and his clanky crew.\nA pirate style quest for amazing treasures and high action gameplay!"
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__naTs4)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/YarrHarrHeist"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__pYrKh
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__hj0Zo)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__xdtLe)}
                    loading={"lazy"}
                  />
                </p.Stack>
              </div>
            </div>
          </div>

          <div
            data-plasmic-name={"hauntedHigh"}
            data-plasmic-override={overrides.hauntedHigh}
            className={classNames(projectcss.all, sty.hauntedHigh)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__ivgO8)}>
              <div className={classNames(projectcss.all, sty.columns__nsigD)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__mr3Oc)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__apR6J)}
                    loading={"lazy"}
                  />
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.column__cDRxc)}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__kfGxK
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "_4KMonitors")
                      ? "Haunted High"
                      : "Haunted High"}
                  </h2>

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__s72J1
                    )}
                  >
                    {
                      "Our first quest and overall project. This was made as a Halloween style experience.\nYou and your fellow students go to a wacky school and attend the lessons by the teachers of this unusual highschool."
                    }
                  </div>

                  <Button
                    className={classNames("__wab_instance", sty.button__yjAn0)}
                    color={"dorkBlue"}
                    link={"https://rec.net/room/HauntedHigh"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___5NybC
                      )}
                    >
                      {"View on Rec.Net"}
                    </div>
                  </Button>
                </p.Stack>
              </div>
            </div>
          </div>

          <p.Stack
            as={"div"}
            data-plasmic-name={"footBar"}
            data-plasmic-override={overrides.footBar}
            hasGap={true}
            className={classNames(projectcss.all, sty.footBar)}
          >
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__h9WWx)}
            >
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__pfTHu)}
              >
                <div
                  className={classNames(projectcss.all, sty.freeBox___2RTa1)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___9790
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "mobileOnly")
                      ? "Contact us\n"
                      : "Contact us\n"}
                  </div>

                  <p.PlasmicLink
                    data-plasmic-name={"openMailapp"}
                    data-plasmic-override={overrides.openMailapp}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.openMailapp,
                      ""
                    )}
                    component={Link}
                    href={"mailto:info@dorksquad.org"}
                    platform={"gatsby"}
                    target={"_blank"}
                    title={"Open mail"}
                  >
                    <p.PlasmicLink
                      data-plasmic-name={"mailtoinfodorksquadnet"}
                      data-plasmic-override={overrides.mailtoinfodorksquadnet}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        sty.mailtoinfodorksquadnet
                      )}
                      component={Link}
                      href={args.mail}
                      platform={"gatsby"}
                      target={"_blank"}
                    >
                      {hasVariant(globalVariants, "screen", "_4KMonitors")
                        ? "info@dorksquad.net"
                        : "info@dorksquad.org"}
                    </p.PlasmicLink>
                  </p.PlasmicLink>
                </div>
              </p.Stack>

              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__xkw6B)}
              >
                <p.PlasmicLink
                  data-plasmic-name={"dorkSquadInstaLink"}
                  data-plasmic-override={overrides.dorkSquadInstaLink}
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.dorkSquadInstaLink
                  )}
                  component={Link}
                  href={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? "#"
                      : "https://www.instagram.com/dorksquad.rr/"
                  }
                  platform={"gatsby"}
                  target={"_blank"}
                >
                  {hasVariant(globalVariants, "screen", "mobileOnly")
                    ? "Shop"
                    : "Instagram"}
                </p.PlasmicLink>

                <p.PlasmicLink
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.link__hLxTs
                  )}
                  component={Link}
                  platform={"gatsby"}
                >
                  {"Rec.Net"}
                </p.PlasmicLink>

                <p.PlasmicLink
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.link__sZ4K1
                  )}
                  component={Link}
                  platform={"gatsby"}
                >
                  {"About"}
                </p.PlasmicLink>

                <p.PlasmicLink
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.link__x163O
                  )}
                  component={Link}
                  href={"https://www.youtube.com/watch?v=dQw4w9WgXcQ"}
                  platform={"gatsby"}
                >
                  {"Help"}
                </p.PlasmicLink>
              </p.Stack>

              {false ? (
                <div className={classNames(projectcss.all, sty.freeBox__tnvzT)}>
                  <button
                    className={classNames(
                      projectcss.all,
                      projectcss.button,
                      projectcss.__wab_text,
                      sty.button__rZrtB
                    )}
                  >
                    {"Sign up"}
                  </button>

                  <p.Stack
                    as={p.PlasmicLink}
                    hasGap={true}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.link__jEbiT
                    )}
                    component={Link}
                    platform={"gatsby"}
                  >
                    {false ? (
                      <IconIcon
                        className={classNames(projectcss.all, sty.svg__p2FjB)}
                        role={"img"}
                      />
                    ) : null}

                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__lHk9O
                      )}
                    >
                      {"Log in"}
                    </div>

                    {false ? (
                      <IconIcon
                        className={classNames(projectcss.all, sty.svg__mNrX)}
                        role={"img"}
                      />
                    ) : null}
                  </p.Stack>
                </div>
              ) : null}
            </p.Stack>
          </p.Stack>
        </p.Stack>
      </div>
    </React.Fragment>
  )
}

const PlasmicDescendants = {
  root: [
    "root",
    "header",
    "img",
    "experiences",
    "services",
    "gallery",
    "about",
    "groupPicture",
    "foreground2",
    "h1",
    "hoarfrost",
    "yuleFest",
    "gruyeres",
    "voidResonance",
    "fishingJamboree",
    "edgeOfUnknown",
    "shibuyaCrossing",
    "runesOfEtheria",
    "pizzaAndOranges",
    "jetSkater",
    "theHeartOfWerahuri",
    "stoneCircle",
    "smoggCityTheRpvpg",
    "dorkReactor",
    "proficioVii",
    "sandySunsetIsland",
    "travelBeyondInc",
    "whatBunker",
    "clockingOff",
    "aostabla",
    "arthurLokinsIsland",
    "theSeaFloor",
    "yarrHarrHeist",
    "hauntedHigh",
    "footBar",
    "openMailapp",
    "mailtoinfodorksquadnet",
    "dorkSquadInstaLink",
  ],

  header: ["header", "img", "experiences", "services", "gallery", "about"],
  img: ["img"],
  experiences: ["experiences"],
  services: ["services"],
  gallery: ["gallery"],
  about: ["about"],
  groupPicture: ["groupPicture", "foreground2", "h1"],
  foreground2: ["foreground2", "h1"],
  h1: ["h1"],
  hoarfrost: ["hoarfrost"],
  yuleFest: ["yuleFest"],
  gruyeres: ["gruyeres"],
  voidResonance: ["voidResonance"],
  fishingJamboree: ["fishingJamboree"],
  edgeOfUnknown: ["edgeOfUnknown"],
  shibuyaCrossing: ["shibuyaCrossing"],
  runesOfEtheria: ["runesOfEtheria"],
  pizzaAndOranges: ["pizzaAndOranges"],
  jetSkater: ["jetSkater"],
  theHeartOfWerahuri: ["theHeartOfWerahuri"],
  stoneCircle: ["stoneCircle"],
  smoggCityTheRpvpg: ["smoggCityTheRpvpg"],
  dorkReactor: ["dorkReactor"],
  proficioVii: ["proficioVii"],
  sandySunsetIsland: ["sandySunsetIsland"],
  travelBeyondInc: ["travelBeyondInc"],
  whatBunker: ["whatBunker"],
  clockingOff: ["clockingOff"],
  aostabla: ["aostabla"],
  arthurLokinsIsland: ["arthurLokinsIsland"],
  theSeaFloor: ["theSeaFloor"],
  yarrHarrHeist: ["yarrHarrHeist"],
  hauntedHigh: ["hauntedHigh"],
  footBar: [
    "footBar",
    "openMailapp",
    "mailtoinfodorksquadnet",
    "dorkSquadInstaLink",
  ],

  openMailapp: ["openMailapp", "mailtoinfodorksquadnet"],
  mailtoinfodorksquadnet: ["mailtoinfodorksquadnet"],
  dorkSquadInstaLink: ["dorkSquadInstaLink"],
}

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicPortfolio__ArgProps,
          internalVariantPropNames: PlasmicPortfolio__VariantProps,
        }),

      [props, nodeName]
    )

    return PlasmicPortfolio__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    })
  }
  if (nodeName === "root") {
    func.displayName = "PlasmicPortfolio"
  } else {
    func.displayName = `PlasmicPortfolio.${nodeName}`
  }
  return func
}

export const PlasmicPortfolio = Object.assign(
  // Top-level PlasmicPortfolio renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    img: makeNodeComponent("img"),
    experiences: makeNodeComponent("experiences"),
    services: makeNodeComponent("services"),
    gallery: makeNodeComponent("gallery"),
    about: makeNodeComponent("about"),
    groupPicture: makeNodeComponent("groupPicture"),
    foreground2: makeNodeComponent("foreground2"),
    h1: makeNodeComponent("h1"),
    hoarfrost: makeNodeComponent("hoarfrost"),
    yuleFest: makeNodeComponent("yuleFest"),
    gruyeres: makeNodeComponent("gruyeres"),
    voidResonance: makeNodeComponent("voidResonance"),
    fishingJamboree: makeNodeComponent("fishingJamboree"),
    edgeOfUnknown: makeNodeComponent("edgeOfUnknown"),
    shibuyaCrossing: makeNodeComponent("shibuyaCrossing"),
    runesOfEtheria: makeNodeComponent("runesOfEtheria"),
    pizzaAndOranges: makeNodeComponent("pizzaAndOranges"),
    jetSkater: makeNodeComponent("jetSkater"),
    theHeartOfWerahuri: makeNodeComponent("theHeartOfWerahuri"),
    stoneCircle: makeNodeComponent("stoneCircle"),
    smoggCityTheRpvpg: makeNodeComponent("smoggCityTheRpvpg"),
    dorkReactor: makeNodeComponent("dorkReactor"),
    proficioVii: makeNodeComponent("proficioVii"),
    sandySunsetIsland: makeNodeComponent("sandySunsetIsland"),
    travelBeyondInc: makeNodeComponent("travelBeyondInc"),
    whatBunker: makeNodeComponent("whatBunker"),
    clockingOff: makeNodeComponent("clockingOff"),
    aostabla: makeNodeComponent("aostabla"),
    arthurLokinsIsland: makeNodeComponent("arthurLokinsIsland"),
    theSeaFloor: makeNodeComponent("theSeaFloor"),
    yarrHarrHeist: makeNodeComponent("yarrHarrHeist"),
    hauntedHigh: makeNodeComponent("hauntedHigh"),
    footBar: makeNodeComponent("footBar"),
    openMailapp: makeNodeComponent("openMailapp"),
    mailtoinfodorksquadnet: makeNodeComponent("mailtoinfodorksquadnet"),
    dorkSquadInstaLink: makeNodeComponent("dorkSquadInstaLink"),
    // Metadata about props expected for PlasmicPortfolio
    internalVariantProps: PlasmicPortfolio__VariantProps,
    internalArgProps: PlasmicPortfolio__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "Portfolio",
      description: "A collection of all of our projects",
      ogImageSrc:
        "https://site-assets.plasmic.app/37235caf5abb4b82502f1e0f51b0163b.jpg",
      canonical: "https://dorksquad.net/portfolio",
    },
  }
)

export default PlasmicPortfolio
/* prettier-ignore-end */
